import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";
import { PFAddressService, validateAddressIsResidential } from "pf-address-service";
import dynamicModuleRegistry from "dynamic-module-registry";
import uiMoney from "ui-money";

class Address extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addr1MsgData: {
        home: {
          errors: { street: {}, aptsuite: {} },
          info: { street: {}, aptsuite: {} },
        },
        mail: {
          errors: { street: {}, aptsuite: {} },
          info: { street: {}, aptsuite: {} },
        },
      },
      addr2MsgData: {
        home: {
          errors: { city: {}, state: {}, zip: {} },
          info: { city: {}, state: {}, zip: {} },
        },
        mail: {
          errors: { city: {}, state: {}, zip: {} },
          info: { city: {}, state: {}, zip: {} },
        },
      },
      isSameAddr: "Yes",
    };

    this.addrSection1 = 1;
    this.addrSection2 = 2;
    this.poBoxAddr = false;
    this.isCommercialAddress = false;
    this.isInvalid = {
      home: {
        street: false,
        aptsuite: false,
        city: false,
      },
      mail: {
        street: false,
        aptsuite: false,
        city: false,
      },
    };

    this.addressMetadata = {
      street: {
        name: "street",
        maxLength: 50,
        placeHolder: "Street",
        error: "Street address is required.",
        invalidStreet: "Invalid Street",
        commercialAddressError: "Commercial address is not allowed.",
        poBoxError: "You cannot enter a PO Box for a home address.",
        info: "Enter street address.",
        info2: "PO Box is not allowed.",
      },
      aptsuite: {
        name: "aptsuite",
        maxLength: 15,
        placeHolder: "Apt. / Suite #",
        error: "",
        invalidAptSuite: "Invalid Apt. / Suite",
        info: "Enter apt. or suite #.",
      },
      city: {
        name: "city",
        maxLength: 23,
        placeHolder: "City",
        error: "City is required.",
        invalidCity: "Invalid city.",
        info: "Enter the city name.",
      },
      state: {
        name: "state",
        error: "State is required.",
        info: "Select state.",
        infoAmount: `${new uiMoney(props.MA_minAmt, "USD").format(
          0,
        )} is the minimum Fixed Rate Plan amount in Massachusetts.`,
      },
      zip: {
        name: "zip",
        maxLength: 5,
        placeHolder: "Zip",
        error: "Please enter a 5-digit zip code.",
        info: "Enter the zip code.  It cannot start with 000.",
      },
      addressToggleLabel: "Is your mailing address the same as your home address?",
    };
    this.usStates = [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "DC",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
    ];
  }

  static defaultProps = {
    secValues: {},
    classes: {
      label: "label",
      field: "field",
      validation: "messaging",
      heading: "heading",
    },
    colLayout: {
      1: {
        1: { sm: 12, lg: 3 },
        2: { sm: 12, lg: 4 },
        3: { sm: 12, lg: 2 },
        4: { sm: 12, lg: 3 },
      },
      2: {
        1: { sm: 12, lg: 3 },
        2: { sm: 12, lg: 2 },
        3: { sm: 12, lg: 2 },
        4: { sm: 12, lg: 2 },
        5: { sm: 12, lg: 3 },
      },
    },
  };

  resetAddr1Message = (fieldName, addressType, value) => {
    const { addr1MsgData } = this.state,
      { addressSectionMetadata } = this.props;

    addressSectionMetadata[addressType][fieldName].status = "";
    addressSectionMetadata[addressType][fieldName].isValid = true;
    addressSectionMetadata[addressType][fieldName].value = value;
    addr1MsgData[addressType].errors[fieldName] = {};
    addr1MsgData[addressType].info[fieldName] = {};

    this.setState({ addr1MsgData });
  };

  resetAddr2Message = (fieldName, addressType, value) => {
    const { addr2MsgData } = this.state,
      { addressSectionMetadata } = this.props;

    addressSectionMetadata[addressType][fieldName].status = "";
    addressSectionMetadata[addressType][fieldName].isValid = true;
    addressSectionMetadata[addressType][fieldName].value = value;

    addr2MsgData[addressType].errors[fieldName] = {};
    addr2MsgData[addressType].info[fieldName] = {};

    this.setState({ addr2MsgData });
  };

  initMsgObj = (part) => {
    if (part === this.addrSection1) {
      return {
        errors: { street: {}, aptsuite: {} },
        info: { street: {}, aptsuite: {} },
      };
    }

    return {
      errors: { city: {}, state: {}, zip: {} },
      info: { city: {}, state: {}, zip: {} },
    };
  };

  setMessage = (msgType, fieldName, id, addressType) => {
    let msg = this.addressMetadata[fieldName][msgType];

    if (msgType === "error") {
      if (fieldName === "street") {
        if (addressType === "home" && this.poBoxAddr) {
          msg = this.addressMetadata[fieldName].poBoxError;
        } else if (addressType === "home" && this.isCommercialAddress) {
          msg = this.addressMetadata[fieldName].commercialAddressError;
        } else if (this.isInvalid[addressType].street) {
          msg = this.addressMetadata[fieldName].invalidStreet;
        }
      } else if (fieldName === "city" && this.isInvalid[addressType].city) {
        msg = this.addressMetadata[fieldName].invalidCity;
      } else if (fieldName === "aptsuite" && this.isInvalid[addressType].aptsuite) {
        msg = this.addressMetadata[fieldName].invalidAptSuite;
      }
    } else if (msgType === "info" && addressType === "home" && fieldName === "street") {
      msg = `${msg}  ${this.addressMetadata[fieldName].info2}`;
    } else if (msgType === "info" && fieldName === "state" && id.includes("MA")) {
      msg = this.addressMetadata[fieldName].infoAmount;
    }

    return {
      type: msgType,
      slug: fieldName,
      id: id,
      msg: msg,
    };
  };

  showMAMessage = (stateValue, addressMetadata, loanAmount, MA_minAmt) => {
    return (
      stateValue === "MA" &&
      this.props.useMinAmountForMA &&
      addressMetadata.city.status !== "invalid" &&
      addressMetadata.zip.status !== "invalid" &&
      (!loanAmount || parseInt(loanAmount, 10) < parseInt(MA_minAmt, 10))
    );
  };

  setAddr1Message = (eventType, msgType, fieldName, id, addressType) => {
    const { addr1MsgData } = this.state,
      { addressSectionMetadata } = this.props,
      msgData = this.initMsgObj(this.addrSection1),
      idPrefix = `pf-${addressType}-addr-`,
      key = msgType === "error" ? "errors" : "info";

    if (eventType === "focus") {
      msgData[key][fieldName] = this.setMessage(msgType, fieldName, id, addressType);
    } else if (eventType === "blur") {
      const streetValue = addressSectionMetadata[addressType].street.value;

      if (!streetValue || this.poBoxAddr || this.isInvalid[addressType].street) {
        msgData[key].street = this.setMessage("error", "street", `${idPrefix}${fieldName}`, addressType);
      }

      msgData[key].aptsuite = this.setMessage("error", "aptsuite", `${idPrefix}${fieldName}`, addressType);
    }

    addr1MsgData[addressType] = msgData;
    this.setState({ addr1MsgData });
  };

  setAddr2Message = (eventType, msgType, fieldName, id, addressType) => {
    const { addr2MsgData } = this.state,
      { addressSectionMetadata } = this.props,
      key = msgType === "error" ? "errors" : "info",
      { zip } = this.addressMetadata,
      idPrefix = `pf-${addressType}-addr-`,
      msgData = this.initMsgObj(this.addrSection2);

    if (eventType === "focus") {
      msgData[key][fieldName] = this.setMessage(msgType, fieldName, id, addressType);
    } else if (eventType === "blur") {
      const cityValue = addressSectionMetadata[addressType].city.value,
        stateValue = addressSectionMetadata[addressType].state.value,
        zipValue = addressSectionMetadata[addressType].zip.value;

      if (!cityValue || (cityValue && this.isInvalid[addressType].city)) {
        msgData[key].city = this.setMessage("error", "city", `${idPrefix}city`, addressType);
        addressSectionMetadata[addressType].city.status = "invalid";
        addressSectionMetadata[addressType].city.isValid = false;
      } else {
        addressSectionMetadata[addressType].city.status = "";
        addressSectionMetadata[addressType].city.isValid = true;
      }

      if (!stateValue) {
        msgData[key].state = this.setMessage("error", "state", `${idPrefix}state`, addressType);
        addressSectionMetadata[addressType].state.status = "invalid";
        addressSectionMetadata[addressType].state.isValid = false;
      } else {
        addressSectionMetadata[addressType].state.status = "";
        addressSectionMetadata[addressType].state.isValid = true;
      }

      if (
        !zipValue ||
        zipValue.length < zip.maxLength ||
        (zipValue.length === zip.maxLength && zipValue.substring(0, 3) === "000")
      ) {
        msgData[key].zip = this.setMessage("error", "zip", `${idPrefix}zip`, addressType);
        addressSectionMetadata[addressType].zip.status = "invalid";
        addressSectionMetadata[addressType].zip.isValid = false;
      } else {
        addressSectionMetadata[addressType].zip.status = "";
        addressSectionMetadata[addressType].zip.isValid = true;
      }
    }

    addr2MsgData[addressType] = msgData;
    this.setState({ addr2MsgData });
  };

  validKey = (ev) => {
    let key = ev.key;

    if (key && key === "Unidentified") {
      key = String.fromCharCode(ev.which ? ev.which : ev.keyCode);
    }

    const { name } = ev.target,
      ZERO = "0",
      NINE = "9",
      LOWERA = "a",
      LOWERZ = "z",
      UPPERA = "A",
      UPPERZ = "Z",
      HYPHEN = "-",
      APOSTROPHE = "'",
      SPACE = " ",
      ARROWLEFT = "ArrowLeft",
      ARROWRIGHT = "ArrowRight",
      DELETE = "Delete",
      BACKSPACE = "Backspace",
      TAB = "Tab",
      PERIOD = ".",
      validNum = key >= ZERO && key <= NINE,
      validLowerCaseChar = key >= LOWERA && key <= LOWERZ,
      validUpperCaseChar = key >= UPPERA && key <= UPPERZ,
      validArrowKey = key === ARROWLEFT || key === ARROWRIGHT,
      validZip = validNum || validArrowKey || key === DELETE || key === BACKSPACE || key === TAB,
      validCity =
        validArrowKey ||
        key === SPACE ||
        key === PERIOD ||
        validLowerCaseChar ||
        validUpperCaseChar ||
        key === APOSTROPHE ||
        key === DELETE ||
        key === BACKSPACE ||
        key === TAB ||
        key === HYPHEN,
      validAptSuite = validNum || validCity,
      validStreet = validNum || validCity;

    if (
      (name === "zip" && !validZip) ||
      (name === "city" && !validCity) ||
      (name === "street" && !validStreet) ||
      (name === "aptsuite" && !validAptSuite)
    ) {
      ev.preventDefault();
    }
  };

  existSpecialChars = (fieldName, str) => {
    const includesNum = fieldName === "street" || fieldName === "aptsuite" ? "" : "\\d+",
      regexStr = '[\\(){}:;|!@#$%^&*_=+~`,"/' + includesNum + "]",
      regex = new RegExp(regexStr, "g");

    return regex.test(str);
  };

  isPOBox = (streetAddr) => {
    const regex = /[\\!@#$%^&*-.,"\/]/gi,
      stAddr = streetAddr.trim().toLowerCase().replace(regex, "");

    return (
      stAddr
        .toLowerCase()
        .match(/(pob)|(pob [1-9]+)|(po box)|(p o box)|(pobox)|(pobox [1-9]+)|(po [1-9]+)|(p o [1-9]+)/) &&
      !stAddr.match(/^[1-9]/)
    );
  };

  handleFocus = (ev) => {
    const { id, name } = ev.target,
      eventType = ev.type;

    let addressType = id.indexOf("home") !== -1 ? "home" : "mail";

    if (name === "street" || name === "aptsuite") {
      this.setAddr1Message(eventType, "info", name, id, addressType);
      this.isInvalid[addressType][name] = false;

      if (name === "street") {
        this.poBoxAddr = false;
      }
    } else if (name === "city" || name === "state" || name === "zip") {
      this.setAddr2Message(eventType, "info", name, id, addressType);

      if (name === "city") {
        this.isInvalid[addressType][name] = false;
      }
    }
  };

  handleBlur = (ev) => {
    const { id, value, name } = ev.target,
      eventType = ev.type,
      elementValue = value ? value.trim() : value,
      { addr1MsgData, addr2MsgData } = this.state,
      { addressSectionMetadata, onEventCallback } = this.props;

    let addressType = id.indexOf("home") !== -1 ? "home" : "mail";

    const addressData = {
      street: addressSectionMetadata[addressType].street.value,
      city: addressSectionMetadata[addressType].city.value,
      state: addressSectionMetadata[addressType].state.value,
      zipcode: addressSectionMetadata[addressType].zip.value,
    };
    const allFieldsFilled = addressData.street && addressData.city && addressData.state && addressData.zipcode;
    if (allFieldsFilled && addressType === "home" && !this.existSpecialChars("street", addressData.street)) {
      validateAddressIsResidential(addressData).then((response) => {
        const isValid = response && response.isValid;
        this.isCommercialAddress = !isValid;
        if (isValid) {
          addressSectionMetadata[addressType].street.status = "";
          addressSectionMetadata[addressType].street.isValid = true;
          addr1MsgData[addressType].errors[name] = {};
          addr1MsgData[addressType].info[name] = {};
        } else {
          addressSectionMetadata[addressType].street.status = "invalid";
          addressSectionMetadata[addressType].street.isValid = false;
          addr1MsgData[addressType].errors.street = this.setMessage(
            "error",
            "street",
            `pf-${addressType}-addr-street`,
            addressType,
          );
          this.setState({ addr1MsgData });
        }
      });
    }

    if (name === "street" || name === "aptsuite") {
      let streetValue = "";

      if (name === "street") {
        streetValue = addressSectionMetadata[addressType].street.value = elementValue;
      } else if (name === "aptsuite") {
        streetValue = addressSectionMetadata[addressType].street.value;
        if (elementValue && this.existSpecialChars(name, elementValue)) {
          this.isInvalid[addressType][name] = true;
          addressSectionMetadata[addressType].aptsuite.status = "invalid";
          addressSectionMetadata[addressType].aptsuite.isValid = false;
        } else {
          addressSectionMetadata[addressType].aptsuite.status = "";
          addressSectionMetadata[addressType].aptsuite.isValid = true;
        }
      }

      if (streetValue && streetValue.length > 0) {
        this.poBoxAddr = this.isPOBox(streetValue);
        this.isInvalid[addressType].street = this.existSpecialChars("street", streetValue);

        if ((this.poBoxAddr && addressType === "home") || this.isInvalid[addressType].street) {
          addressSectionMetadata[addressType].street.status = "invalid";
          addressSectionMetadata[addressType].street.isValid = false;
        } else {
          addressSectionMetadata[addressType].street.status = "";
          addressSectionMetadata[addressType].street.isValid = true;
          addr1MsgData[addressType].errors[name] = {};
          addr1MsgData[addressType].info[name] = {};
          this.setState({ addr1MsgData });
        }
      } else {
        addressSectionMetadata[addressType].street.status = "invalid";
        addressSectionMetadata[addressType].street.isValid = false;
      }

      if (
        !streetValue ||
        (this.poBoxAddr && addressType === "home") ||
        this.isInvalid[addressType].street ||
        this.isInvalid[addressType].aptsuite
      ) {
        this.setAddr1Message(
          eventType,
          "error",
          this.isInvalid[addressType].aptsuite ? "aptsuite" : "street",
          id,
          addressType,
        );
      } else if (name === "aptsuite") {
        this.resetAddr1Message(name, addressType, value);
      }
    } else if (name === "zip") {
      this.setAddr2Message(eventType, "error", name, id, addressType);
    } else if (name === "city" || name === "state") {
      if (elementValue) {
        addressSectionMetadata[addressType][name].status = "";
        addressSectionMetadata[addressType][name].isValid = true;

        if (name === "city" && this.existSpecialChars(name, elementValue)) {
          this.isInvalid[addressType][name] = true;
          addressSectionMetadata[addressType][name].status = "invalid";
          addressSectionMetadata[addressType][name].isValid = false;
        }
      }

      addr2MsgData[addressType].errors[name] = {};
      addr2MsgData[addressType].info[name] = {};
      this.setState({ addr2MsgData });
    }

    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, addressSectionMetadata);
    }
  };

  handleChange = (ev) => {
    const { id, value, name } = ev.target,
      { addressSectionMetadata, onEventCallback } = this.props,
      { addr2MsgData } = this.state,
      elementValue = value ? value.trim() : value;

    let addressType = id.indexOf("home") !== -1 ? "home" : "mail";

    addressSectionMetadata[addressType][name].status = "";
    addressSectionMetadata[addressType][name].isValid = false;
    addressSectionMetadata[addressType][name].value = elementValue;

    if (name !== "state" && elementValue) {
      addressSectionMetadata[addressType][name].isValid = true;
    }

    if (name === "state" && onEventCallback && typeof onEventCallback === "function") {
      if (value) {
        addressSectionMetadata[addressType][name].isValid = true;
        addr2MsgData[addressType].errors[name] = {};
        addr2MsgData[addressType].info[name] = {};
        this.setState({ addr2MsgData });
      }
      onEventCallback(ev, addressSectionMetadata);
    }
  };

  handleAddrToggle = (ev) => {
    const { onEventCallback, addressSectionMetadata } = this.props;

    addressSectionMetadata.isSameAddr = ev.target.value;

    this.setState({ isSameAddr: ev.target.value });

    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, addressSectionMetadata);
    }
  };

  // Smarty Streets event handler
  handleSuggestionSelected = (id, suggestion) => {
    const { addressSectionMetadata, onEventCallback } = this.props,
      { addr1MsgData, addr2MsgData } = this.state;

    let addressType = id.indexOf("home") !== -1 ? "home" : "mail",
      street = suggestion.street,
      city = suggestion.city,
      state = suggestion.state,
      zip = suggestion.zip;

    if (street && street.length > 0) {
      addressSectionMetadata[addressType].street.value = street;
      addressSectionMetadata[addressType].street.isValid = true;
      addressSectionMetadata[addressType].street.status = "";
      addr1MsgData[addressType] = this.initMsgObj(this.addrSection1);
      this.isInvalid[addressType].street = false;
    }

    if (city && city.length > 0) {
      addressSectionMetadata[addressType].city.value = city;
      addressSectionMetadata[addressType].city.isValid = true;
      addressSectionMetadata[addressType].city.status = "";
      addr2MsgData[addressType].errors.city = {};
      addr2MsgData[addressType].info.city = {};
      this.isInvalid[addressType].city = false;
    }

    if (state && state.length > 0) {
      addressSectionMetadata[addressType].state.value = state;
      addressSectionMetadata[addressType].state.isValid = true;
      addressSectionMetadata[addressType].state.status = "";
      addr2MsgData[addressType].errors.state = {};
      addr2MsgData[addressType].info.state = {};
    }

    if (zip && zip.length > 0) {
      addressSectionMetadata[addressType].zip.value = zip;
      if (zip.length === 5) {
        addressSectionMetadata[addressType].zip.isValid = true;
        addressSectionMetadata[addressType].zip.status = "";
        addr2MsgData[addressType].errors.zip = {};
        addr2MsgData[addressType].info.zip = {};
      } else {
        addressSectionMetadata[addressType].zip.isValid = false;
        addressSectionMetadata[addressType].zip.status = "invalid";
      }
    } else if (addressSectionMetadata[addressType].zip.value) {
      addressSectionMetadata[addressType].zip.value = null;
      addressSectionMetadata[addressType].zip.isValid = false;
      addressSectionMetadata[addressType].zip.status = "invalid";
    }

    if (addressSectionMetadata[addressType].aptsuite.value) {
      addressSectionMetadata[addressType].aptsuite.value = null;
      addressSectionMetadata[addressType].aptsuite.status = "";
      this.isInvalid[addressType].aptsuite = false;
    }

    this.setState({ addr1MsgData, addr2MsgData });

    if (onEventCallback && typeof onEventCallback === "function") {
      let ev = { target: { id, name: "smartyStreetsSuggestion" } };
      onEventCallback(ev, addressSectionMetadata);
    }
  };

  handleOnKeyDown = (ev) => {
    // prevent form submission when hitting 'Enter' key on address-toggle field YES/NO radio buttons
    const { key } = ev,
      ENTER = "Enter";
    if (key === ENTER) {
      ev.preventDefault();
    }
  };

  renderAddrToggle = () => {
    const { addressToggleLabel } = this.addressMetadata,
      YES = "Yes",
      NO = "No",
      prefix = "pf-mailing-",
      slug = "addrsame",
      yesId = `${prefix}${slug}-${YES}`,
      noId = `${prefix}${slug}-${NO}`,
      { isSameAddr } = this.state;

    return (
      <Row>
        <Col className="sm-collapse" width={{ sm: 12, lg: 2 }} />
        <Col className="home-mail-addr-toggle" width={{ sm: 12, lg: 7 }}>
          <span className="radio-list">
            <span className="text label">{addressToggleLabel}</span>
            <span className="radio-group first">
              <input
                type="radio"
                id={yesId}
                name={slug}
                checked={isSameAddr === YES}
                value={YES}
                onChange={this.handleAddrToggle}
                onKeyDown={this.handleOnKeyDown}
              />
              <label className="inline-block" htmlFor={yesId}>
                {YES}
              </label>
            </span>
            <span className="radio-group">
              <input
                type="radio"
                id={noId}
                name={slug}
                checked={isSameAddr === NO}
                value={NO}
                onChange={this.handleAddrToggle}
                onKeyDown={this.handleOnKeyDown}
              />
              <label className="inline-block" htmlFor={noId}>
                {NO}
              </label>
            </span>
          </span>
        </Col>
      </Row>
    );
  };

  renderAddrSec1 = (addressType) => {
    let prefix, preText;
    // This will render the give us the input props that will enable us to customize the input layout
    const renderInputComponent = (inputProps) => (
      <Fragment>
        <label id="street-label" htmlFor="pf-borrower-street-address" className="show-for-sr">
          {street.placeHolder} name
        </label>
        <input {...inputProps} />
      </Fragment>
    );

    const { colLayout, classes, addressSectionMetadata } = this.props,
      { addr1MsgData } = this.state,
      { street, aptsuite } = this.addressMetadata,
      secAccess = addressSectionMetadata[addressType],
      streetStatus = secAccess[street.name].status,
      aptSuiteStatus = secAccess[aptsuite.name].status;

    switch (addressType) {
      case "mail":
        prefix = "pf-mail-addr-";
        preText = "Mailing";
        break;
      default:
        prefix = "pf-home-addr-";
        preText = "Home";
        break;
    }

    if (streetStatus === "invalid" && !this.poBoxAddr) {
      let streetMsg = this.setMessage("error", "street", prefix + "street", addressType);
      addr1MsgData[addressType].errors.street = streetMsg;
    }

    const smartyStreetsConfig = dynamicModuleRegistry.get("smartyStreetsConfig");
    const streetInputProps = {
      className: `${streetStatus}`,
      "aria-labelledby": "street-label",
      id: `${prefix}${street.name}`,
      name: `${street.name}`,
      placeholder: `${street.placeHolder}`,
      autoComplete: secAccess[street.name].autocomplete || null,
      value: secAccess.street.value,
      onKeyDown: this.validKey,
    };
    const containerProps = {
      "aria-labelledby": "street-label",
      id: "pf-borrower-street-address",
    };

    const renderSuggesionContainer = (suggestion) => <label aria-label={suggestion.name}>{suggestion.name}</label>;

    let streetInput = (
      <PFAddressService
        renderInputComponent={renderInputComponent}
        renderSuggesionContainer={renderSuggesionContainer}
        containerProps={containerProps}
        inputprops={streetInputProps}
        onBlurCallback={this.handleBlur}
        onFocusCallback={this.handleFocus}
        onSuggestionSelected={this.handleSuggestionSelected.bind(this)}
        smartystreetsconfig={smartyStreetsConfig}
      />
    );

    if (secAccess.street.autofill) {
      streetInput = (
        <input
          key={secAccess.street.value}
          id={prefix + street.name}
          name={street.name}
          className={streetStatus}
          maxLength={street.maxLength}
          type="text"
          placeholder={street.placeHolder}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          defaultValue={secAccess.street.value}
        />
      );
    }

    return (
      <Row className="pf-pi1-addr-sec1 overflow-visible">
        <Col className={classes.label} width={colLayout[1][1]}>
          <label id={`${preText}-address-title`}>{`${preText} Address`}</label>
        </Col>
        <Col className={classes.field} width={colLayout[1][2]}>
          {streetInput}
        </Col>
        <Col className={classes.field} width={colLayout[1][3]}>
          <label htmlFor={prefix + aptsuite.name} className="show-for-sr">
            Apartment or suite number
          </label>
          <input
            key={addressSectionMetadata[addressType].aptsuite.value}
            id={prefix + aptsuite.name}
            name={aptsuite.name}
            className={aptSuiteStatus}
            maxLength={aptsuite.maxLength}
            type="text"
            placeholder={aptsuite.placeHolder}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onKeyDown={this.validKey}
            defaultValue={addressSectionMetadata[addressType].aptsuite.value}
            autoComplete={secAccess[aptsuite.name].autocomplete || null}
          />
        </Col>
        <Col className={classes.validation} width={colLayout[1][4]}>
          <ValidationMsg who="AddrSec1" filterFields={["street", "aptsuite"]} msgs={addr1MsgData[addressType]} />
        </Col>
      </Row>
    );
  };

  renderAddrSec2 = (addressType) => {
    let prefix, preText;

    const { colLayout, classes, addressSectionMetadata, loanAmount, MA_minAmt } = this.props,
      { addr2MsgData } = this.state,
      { city, state, zip } = this.addressMetadata,
      secAccess = addressSectionMetadata[addressType],
      cityStatus = secAccess[city.name].status,
      stateStatus = secAccess[state.name].status,
      stateValue = secAccess[state.name].value,
      zipStatus = secAccess[zip.name].status,
      cityAutoComplete = secAccess[city.name].autocomplete || null,
      stateAutoComplete = secAccess[state.name].autocomplete || null,
      zipAutoComplete = secAccess[zip.name].autocomplete || null;

    switch (addressType) {
      case "mail":
        prefix = "pf-mail-addr-";
        preText = "Mailing";
        break;
      default:
        prefix = "pf-home-addr-";
        preText = "Home";
        break;
    }

    if (cityStatus === "invalid") {
      const cityMsg = this.setMessage("error", city.name, prefix + city.name, addressType);
      addr2MsgData[addressType].errors.city = cityMsg;
    }

    if (stateStatus === "invalid") {
      const stateMsg = this.setMessage("error", state.name, prefix + state.name, addressType);
      addr2MsgData[addressType].errors.state = stateMsg;
    }

    if (!addr2MsgData[addressType].info.state.msg || !addr2MsgData[addressType].info.state.msg.includes("Select")) {
      if (this.showMAMessage(stateValue, addressSectionMetadata[addressType], loanAmount, MA_minAmt)) {
        addr2MsgData[addressType].info.state = this.setMessage("info", "state", "pf-home-addr-state-MA", addressType);
      } else {
        addr2MsgData[addressType].info.state = {};
      }
    }

    if (zipStatus === "invalid") {
      const zipMsg = this.setMessage("error", zip.name, prefix + zip.name, addressType);
      addr2MsgData[addressType].errors.zip = zipMsg;
    }

    return (
      <Row className="pf-pi1-addr-sec2 overflow-visible">
        <Col className={classes.label} width={colLayout[2][1]}>
          <label className="show-for-sr" htmlFor={prefix + city.name}>
            {" "}
            {preText} Address City
          </label>
        </Col>
        <Col className={classes.field} width={colLayout[2][2]}>
          <input
            key={addressSectionMetadata[addressType][city.name].value}
            id={prefix + city.name}
            name={city.name}
            defaultValue={addressSectionMetadata[addressType][city.name].value}
            className={cityStatus}
            type="text"
            placeholder={city.placeHolder}
            maxLength={city.maxLength}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            autoComplete={cityAutoComplete}
            onKeyDown={this.validKey}
          />
        </Col>
        <Col className={classes.field} width={colLayout[2][3]}>
          <label className="show-for-sr" htmlFor={prefix + state.name}>
            {preText} Address State
          </label>
          <select
            key={addressSectionMetadata[addressType][state.name].value}
            id={prefix + state.name}
            name={state.name}
            defaultValue={addressSectionMetadata[addressType][state.name].value}
            className={stateStatus}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            autoComplete={stateAutoComplete}
          >
            <option value="">State</option>
            {this.usStates.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
        </Col>
        <Col className={classes.field} width={colLayout[2][4]}>
          <label className="show-for-sr" htmlFor={prefix + zip.name}>
            {preText} Address Zip Code
          </label>
          <input
            key={addressSectionMetadata[addressType][zip.name].value}
            id={prefix + zip.name}
            name={zip.name}
            defaultValue={addressSectionMetadata[addressType][zip.name].value}
            className={zipStatus}
            type="tel"
            maxLength={zip.maxLength}
            placeholder={zip.placeHolder}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onKeyDown={this.validKey}
            autoComplete={zipAutoComplete}
          />
        </Col>
        <Col className={classes.validation} width={colLayout[2][5]}>
          <ValidationMsg who="AddrSec2" filterFields={["city", "state", "zip"]} msgs={addr2MsgData[addressType]} />
        </Col>
      </Row>
    );
  };

  render() {
    const { isSameAddr } = this.state,
      HOME = "home",
      MAIL = "mail";

    return (
      <Fragment>
        <fieldset>
          <legend className="show-for-sr">Home Address</legend>
          {this.renderAddrSec1(HOME)}
          {this.renderAddrSec2(HOME)}
          {this.renderAddrToggle()}
        </fieldset>
        {isSameAddr === "No" && (
          <fieldset>
            <legend className="show-for-sr">Mailing Address</legend>
            {this.renderAddrSec1(MAIL)}
            {this.renderAddrSec2(MAIL)}
          </fieldset>
        )}
      </Fragment>
    );
  }
}

Address.propTypes = {
  colLayout: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  secValues: PropTypes.object.isRequired,
  addressSectionMetadata: PropTypes.object.isRequired,
  onEventCallback: PropTypes.func.isRequired,
  defaultValues: PropTypes.object,
  loanAmount: PropTypes.string.isRequired,
  MA_minAmt: PropTypes.number.isRequired,
  useMinAmountForMA: PropTypes.bool.isRequired,
};

export default Address;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');